import type { State } from '../../typings'

export const openContentProducer = (
  state: State,
  payload: HTMLButtonElement,
): State => ({
  ...state,
  contentOpened: true,
  popoverEl: payload,
})
